module.exports = __webpack_public_path__ + "img/login.4cfcd215.png";